import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";

const rootElement = document.getElementById("root")!;
const pathname = window.location.pathname.replace(/\/$/, "") || "/";

if (pathname === "/") {
  const root = createRoot(rootElement);
  import("./pages/Home").then(({ default: Home }) => root.render(<Home />));
} else {
  document.getElementById("homepage-hero")?.remove();
  const prerenderedRoutes = {
    "/workshop": () => import("./pages/AILeadershipWorkshop"),
    "/audit": () => import("./pages/AIClarityAudit"),
    "/scorecard": () => import("./pages/Scorecard"),
  } as const;
  const loadPrerenderedPage = prerenderedRoutes[pathname as keyof typeof prerenderedRoutes];

  if (rootElement.dataset.prerendered === "true" && loadPrerenderedPage) {
    loadPrerenderedPage().then(({ default: Page }) => hydrateRoot(rootElement, <Page />));
  } else {
    import("./App").then(({ default: App }) => createRoot(rootElement).render(<App />));
  }
}
